var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8332 16.3333C18.8332 16.7754 18.6576 17.1993 18.345 17.5118C18.0325 17.8244 17.6085 18 17.1665 18H3.83317C3.39114 18 2.96722 17.8244 2.65466 17.5118C2.3421 17.1993 2.1665 16.7754 2.1665 16.3333V4.66667C2.1665 4.22464 2.3421 3.80072 2.65466 3.48816C2.96722 3.17559 3.39114 3 3.83317 3H7.99984L9.6665 5.5H17.1665C17.6085 5.5 18.0325 5.67559 18.345 5.98816C18.6576 6.30072 18.8332 6.72464 18.8332 7.16667V16.3333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.9c48001fc3377b200464d9a0c8e1dcbd.svg";
export { ForwardRef as ReactComponent };